import React from "react";
import ExperienceRoleItem from "./ExperienceRoleItem";

export default function ExperienceRoleList(
    {
        items,
        numberOfItems,
        parentOrder
    } ) {

    return (
        <div>
            { items
                ?.sort( ( a, b ) => a.order - b.order )
                .map( role => (
                    <ExperienceRoleItem
                        key={ role.order }
                        item={ role }
                        parentOrder={ parentOrder }
                        numberOfItems={ numberOfItems }
                    />
                ) ) }
        </div>
    );
}
